import * as React from 'react'
import { redirect } from 'react-router-dom'

import { PurchaseRequestDetailDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const PurchaseRequestDetailHeader = React.lazy(
  () => import('modules/procurement/components/purchaseRequests/PurchaseRequestDetailHeader')
)

const MyPurchaseRequestDetailSummaryPage = React.lazy(
  () =>
    import('modules/procurement/pages/my_purchases/MyPurchaseRequestDetailPage/MyPurchaseRequestDetailSummaryPage')
)

const MyPurchaseRequestDetailAttachmentsPage = React.lazy(
  () =>
    import('modules/procurement/pages/my_purchases/MyPurchaseRequestDetailPage/MyPurchaseRequestDetailAttachmentsPage')
)

const MyPurchaseRequestDetailCommentsPage = React.lazy(
  () =>
    import('modules/procurement/pages/my_purchases/MyPurchaseRequestDetailPage/MyPurchaseRequestDetailCommentsPage')
)

const NewRequestPage = React.lazy(
  () => import('modules/procurement/pages/my_purchases/NewRequestPage')
)
const RootPage = React.lazy(() => import('modules/procurement/pages/my_purchases/RootPage'))

export const myPurchasesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.myPurchases.path,
      element: <RootPage />,
      handle: {
        module: 'my_spending',
        meta: () => ({
          title: i18n.t('procurement.purchase_requests.my_purchase_requests.title'),
          illustration: 'money-spreadsheet',
        }),
      },
      children: [
        {
          path: navigation.myPurchases.newRequest.path,

          handle: {
            meta: () => ({
              title: i18n.t('procurement.new_request.breadcrumb'),
              illustration: 'money-spreadsheet',
              description: i18n.t('procurement.new_request.description'),
            }),
          },
          element: <NewRequestPage />,
        },
        {
          path: navigation.myPurchases.detail.path,
          handle: {
            resource: true,
            meta: ({ watchQuery, params, session }) => {
              return watchQuery({
                query: PurchaseRequestDetailDocument,
                variables: {
                  id: Number(params.id),
                  companyId: session.company.id,
                },
                fetchPolicy: 'cache-and-network',
              }).map(({ data }) => {
                const purchaseRequest = data?.procurement?.purchaseRequest

                return {
                  title: purchaseRequest?.description,
                  headerComponent: purchaseRequest ? (
                    <PurchaseRequestDetailHeader
                      purchaseRequest={purchaseRequest}
                      onlyOwnRequests
                    />
                  ) : null,
                  subNavigation: purchaseRequest && [
                    {
                      id: 'summary',
                      title: i18n.t('procurement.purchase_requests.detail.tabs.summary'),
                      href: navigation.myPurchases.detail.summary.fullPath({
                        id: purchaseRequest.id,
                      }),
                      isVisible: true,
                    },
                    {
                      id: 'attachments',
                      title: i18n.t('procurement.purchase_requests.detail.tabs.attachments'),
                      href: navigation.myPurchases.detail.attachments.fullPath({
                        id: purchaseRequest.id,
                      }),
                      isVisible: true,
                    },
                    {
                      id: 'comments',
                      title: i18n.t('procurement.purchase_requests.detail.tabs.comments'),
                      href: navigation.myPurchases.detail.comments.fullPath({
                        id: purchaseRequest.id,
                      }),
                      isVisible: true,
                    },
                  ],
                }
              })
            },
          },
          children: [
            {
              index: true,
              loader: ({ params }) => {
                return redirect(
                  navigation.myPurchases.detail.summary.fullPath({
                    id: Number(params.id),
                  })
                )
              },
            },
            {
              path: navigation.myPurchases.detail.summary.path,
              element: <MyPurchaseRequestDetailSummaryPage />,
            },
            {
              path: navigation.myPurchases.detail.attachments.path,
              element: <MyPurchaseRequestDetailAttachmentsPage />,
            },
            {
              path: navigation.myPurchases.detail.comments.path,
              element: <MyPurchaseRequestDetailCommentsPage />,
            },
          ],
        },
      ],
    },
  ]
}
